<template>
  <div>
    <vue-headful v-if="page.fields.seo" :title="page.fields.seo.seo_title" :description="page.fields.seo.meta_description" />
    <SeoSchema v-if="page.fields.seo" :json="page.fields.seo.schema" />
    <Banner
      :bannerId="page.fields.hero_image"
      type="image"
      :description="page.fields.hero_description"
      :location="page.fields.hero_location"
      :link="page.fields.hero_link"
      :imageAlt="page.fields.hero_image_alt_text"
    />
    <div class="container">
      <div class="row" id="anchor">
        <div class="col-lg-12">
          <h1>{{ page.fields.hero_text }}</h1>
        </div>
      </div>
      <div class="row pb-5">
        <div class="left-content col-lg-4">
          <blockquote>{{ page.fields.callout_text }}</blockquote>
        </div>
        <div class="right-content col-lg-8 text-left">
          <p data-swiftype-name="body" data-swiftype-type="text">{{ page.fields.callout_description }}</p>
          <div class="text-center">
            <button class="button" @click="showOrderForm">Get the Guide <span class="ani-chevron"> > </span></button>
          </div>
        </div>
      </div>
    </div>
    <Tryptic />
    <div class="container-fluid explore-alabama">
      <div class="row">
        <AttractionSlider words="Explore our Cities" :destinations="citydestinations" />
        <AttractionSlider words="Explore our Beaches" :destinations="gulfdestinations" />
      </div>
    </div>
    <TripIdeas2 />
    <AttractionFilter defaultSearch="birmingham-and-tuscaloosa" />
    <Feedback pageType="page" />
    <Footer />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import Butter from 'buttercms';
import Footer from '@/components/Common/Footer.vue';
import AttractionSlider from '@/components/PlacesToGo/Attractions/AttractionSlider.vue';
import Banner from '@/components/Common/Banner.vue';
import HeaderText from '@/components/Common/HeaderText.vue';
import Tryptic from '@/components/PlacesToGo/Tryptic.vue';
import TripIdeas2 from '@/components/PlacesToGo/Common/TripIdeas2.vue';
import AttractionFilter from '@/components/PlacesToGo/Common/AttractionFilter.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  data() {
    return {
      citydestinations: [],
      gulfdestinations: [],
      page: {
        fields: {},
      },
    };
  },
  methods: {
    getPage() {
      butter.page
        .retrieve('*', 'places-to-go', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  async created() {
    this.getPage();
    await axios
      .get(`${process.env.VUE_APP_API2}placesToGo`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      })
      .then((response) => {
        this.citydestinations = response.data.cityDestinations;
        this.gulfdestinations = response.data.beachDestinations;
      });
  },
  components: {
    Banner,
    HeaderText,
    Tryptic,
    TripIdeas2,
    AttractionSlider,
    AttractionFilter,
    Footer,
  },
})
class PlacesToGo extends Vue {
  showOrderForm() {
    this.$store.dispatch('guideModal/showModal');
  }
}
export default PlacesToGo;
</script>

<style scoped>
.scroll-down {
  display: none;
}

@media only screen and (min-width: 769px) {
  .scroll-down {
    display: inherit;
  }
}

a.scroll-down {
  position: relative;
  top: -130px;
  font-size: 38px;
  color: #fff;
  cursor: pointer;
}
a:hover.scroll-down,
a:active.scroll-down,
a:focus.scroll-down {
  text-decoration: underline;
}

.explore-alabama {
  margin: 65px 0;
}

.mouse-image {
  margin-top: -10px;
  padding: 0 5px;
}

.left-content {
  border-right: solid 2px #4e97b2;
  padding: 50px 20px 0px 0px;
}

.right-content {
  padding: 100px 0px 0px 30px;
}

@media only screen and (max-width: 768px) {
  .left-content {
    border-right: none;
    text-align: left;
    padding: 50px 30px 0px 30px;
  }
  h1 {
    font-size: 60px;
  }

  .right-content {
    padding: 30px;
  }
  .button {
    width: 100%;
    display: block;
  }
  .ani-chevron {
    top: 9px;
    right: auto;
  }
  .pb-5 {
    padding-bottom: 0px !important;
  }
}
</style>
